<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Additional Inspection Filters</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <tr>
      @if (dialogData.referenceFilter.visible) {
        <mat-form-field
          class="filterField"
          id="referenceFilter"
          >
          <mat-label>Inspect. Reference</mat-label>
          <input #first [(ngModel)]="dialogResult.reference" matInput />
          @if (dialogResult.reference) {
            <button
              (click)="clearInspectionReferenceField()"
              mat-icon-button
              matSuffix
              >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (dialogData.originFilter.visible) {
        <mat-form-field
          class="filterField"
          id="originFilter"
          >
          <mat-label>Origin</mat-label>
          <mat-select
            #originSelect
            [(value)]="dialogResult.origin"
            (selectionChange)="getOriginSelection($event)"
            >
            @for (value of dialogData.originFilter.options; track value) {
              <mat-option
                [value]="value"
                >
                {{ value }}
              </mat-option>
            }
          </mat-select>
          @if (dialogResult.origin) {
            <button
              id="originButton"
              (click)="clearDropDownFieldEvent($event)"
              mat-icon-button
              matSuffix
              >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (dialogData.typeFilter.visible) {
        <mat-form-field
          class="filterField"
          id="typeFilter"
          >
          <mat-label>Type</mat-label>
          <mat-select
            #typeSelect
            [(value)]="dialogResult.type"
            (selectionChange)="getTypeSelection($event)"
            >
            @for (value of dialogData.typeFilter.options; track value) {
              <mat-option
                [value]="value.id"
                >
                {{ value.name }}
              </mat-option>
            }
          </mat-select>
          @if (dialogResult.type) {
            <button
              id="typeButton"
              (click)="clearDropDownFieldEvent($event)"
              mat-icon-button
              matSuffix
              >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (dialogData.creationDateFromFilter.visible) {
        <mat-form-field
          class="filterField"
          id="creationDateFilter"
          >
          <mat-label>Creation Date</mat-label>
          <mat-date-range-input [rangePicker]="picker1">
            <input
              [(ngModel)]="dialogResult.creationDateFrom"
              matStartDate
              placeholder="Start date"
              />
              <input
                [(ngModel)]="dialogResult.creationDateTo"
                matEndDate
                placeholder="End date"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                [for]="picker1"
                matIconSuffix
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker1></mat-date-range-picker>
              @if (dialogResult.creationDateTo) {
                <button
                  (click)="clearCreationDateField()"
                  mat-icon-button
                  matSuffix
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          }

          @if (dialogData.vesselNameFilter.visible) {
            <mat-form-field
              class="filterField"
              id="vesselNameFilter"
              >
              <mat-label>Vessel Name</mat-label>
              <input #first [(ngModel)]="dialogResult.vesselName" matInput />
              @if (dialogResult.vesselName) {
                <button
                  (click)="clearVesselNameField()"
                  mat-icon-button
                  matSuffix
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          }

          @if (dialogData.closeDateFilter.visible) {
            <mat-form-field
              class="filterField"
              id="closeDateFilter"
              >
              <mat-label>Closing Date</mat-label>
              <input
                [(ngModel)]="dialogResult.closeDate"
                [matDatepicker]="picker2"
                matInput
                />
                <mat-datepicker-toggle [for]="picker2" matSuffix>
                </mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                @if (dialogResult.closeDate) {
                  <button
                    (click)="clearCloseDateField()"
                    mat-icon-button
                    matSuffix
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            }
          </tr>
        </mat-card-content>
        <mat-card-actions align="end">
          <button id="cancel-additional-filters" (click)="cancel()" mat-button>
            CANCEL
          </button>
          <button
            id="save-additional-filters"
            (click)="apply()"
            mat-button
            color="primary"
            >
            APPLY
          </button>
        </mat-card-actions>
      </mat-card>
